/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import { queryString } from '@utils/format';

export const actions = {
  async fetch({ rootState }, payload) {
    const id = rootState.auth.instansi_id;

    return await http.get(`psp/i/${id}/pelatihan/imbas?${queryString(payload.params)}`).then(({ data }) => data);
  },

  async peserta({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const { data } = await http.get(`psp/i/${id}/pelatihan/imbas/${payload.id}/fetch`);

    return data;
  },

  async candidate({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const { data } = await http.get(`psp/i/${id}/pelatihan/imbas/${payload.id}/guru`);

    return data;
  },

  save({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `psp/i/${id}/pelatihan/imbas/${payload.id}/save`;
    return http.post(url, payload.params).then(({ data }) => data);
  },

  reset({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `psp/i/${id}/pelatihan/imbas/${payload.id}/reset`;
    return http.post(url, payload.params).then(({ data }) => data);
  },

  downloadList({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `${process.env.VUE_APP_API_URL}/psp/i/${id}/peserta/${payload.type}/${payload.url}?${queryString(
      payload.params
    )}`;
    return Promise.resolve(url);
  },
};
